import { ButtonHTMLAttributes, JSX } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
}

export function Button({ children, loading, disabled, className, ...props }: ButtonProps): JSX.Element {
  const isDisabled = loading || disabled;

  return (
    <button {...props} disabled={isDisabled} className={`${className} position-relative`}>
      <div className={loading ? 'invisible' : ''}>{children}</div>
      {loading && (
        <div className="absolute">
          <span className="loading loading-dots" />
        </div>
      )}
    </button>
  );
}
